<section class="heroSection">
    <div class="container">
        <div class="row align-items-end">
            <div class="col-lg-6 col-md-6">
                <div class="hero-content section-pd">
                    <span class="banner-blur">
                        <img src="/assets/images/homepage/banner-blur.svg" width="1333" height="1312" alt="background-banner" priority />
                    </span>
                    <h1 class="trinka-sub-title">隱私優先的AI寫作幫手</h1>
                    <h2>文法與寫作，完美到位</h2>
                    <p>Trinka 是專為學術、技術和正式寫作設計的線上 AI 文法檢查工具，幫你精準修正句子，同時嚴格保護你的個人資料。</p>
                    <div class="btn-group">
                        <a id="homeSignUpforFree" href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">免費開始使用</a>
                        <span class="no-credits">無需綁定信用卡</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="home_banner">
                    <div class="trinka-banner-content">
                        <h3>
                            獨家專利 AI 技術
                        </h3>
                        <ng-container *ngFor="let tool of tools">
                            <a [routerLink]="[tool.link]" [attr.aria-label]="tool.label">
                                <img [src]="tool.imgSrc" width="30" height="30" alt="{{ tool.alt }}" loading="lazy" />
                                {{ tool.label }}
                            </a>
                        </ng-container>
                    </div>
                    <div class="home_img">
                        <img src="/assets/images/human-page-banner.webp" width="456" height="511" alt="human checking grammar errors" priority fetchpriority="high" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-global-leaders></app-global-leaders>

<section class="section-pd allFeaturesSection bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-11">
                <div class="trinka-title text-center ">
                    <h2>您的專屬寫作空間 — 嚴格保護隱私</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Trinka 的文法檢查工具在提升寫作清晰度和表達效果的同時，始終優先保障您的資料隱私。憑藉先進的 AI 技術與強大的安全防護功能，讓您無憂創作，安心掌握自己的資料。</p>

                </div>
            </div>
            <div class="col-12">
                <div class="trinkaToggleButton mb-3 justify-content-center">
                    <div class="trinkaToogleWrapper bg-grey bg-white">
                        <p>英文</p>
                        <label class="switch" style="margin: 0 8px;" aria-label="toggle languages selector">
                            <input type="checkbox" id="languageSelector" [(ngModel)]="showLanguages" checked />
                            <span class="slider-rd round"></span>
                        </label>
                        <p>西班牙文</p>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="features-container" id="grammarchecker">
                    <span class="shape"></span>
                    <div id="tile-1">
                        <ul class="nav nav-pills nav-justified" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" data-toggle="pill" href="#grammarChecker" role="tab" aria-selected="true">文法檢查</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" data-toggle="pill" href="#proofread" role="tab" aria-selected="false">自動文件編輯</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" data-toggle="pill" href="#latex" role="tab" aria-selected="false">LaTeX文件校對</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" data-toggle="pill" href="#consistencyCheck" role="tab" aria-selected="false">一致性檢查</a>
                            </li>
                            <!-- <div class="slider"></div> -->
                        </ul>
                    </div>
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div id="grammarChecker" class="container tab-pane active">
                            <p>Trinka 的文法檢查工具在提升寫作清晰度和表達效果的同時，始終將您的資料隱私擺在第一位。憑藉先進的 AI 技術和強大安全防護功能，讓您無後顧之憂，自在掌控自己的資料。</p>
                            <div class="image" [ngClass]="{'hidden': showLanguages}">
                                <!-- <img src="/assets/images/homepage/grammar-checker.svg" alt="grammar checker"  /> -->
                                <picture>
                                    <source srcset="/assets/images/homepage/grammar-checker.webp" type="image/webp">
                                    <img src="/assets/images/homepage/grammar-checker.png" width="782" height="460" alt="grammar-checker">
                                </picture>
                            </div>
                            <div class="image" [ngClass]="{'hidden': !showLanguages}">
                                <picture>
                                    <source srcset="/assets/images/homepage/spanish/grammar-checker.webp" type="image/webp">
                                    <img src="/assets/images/homepage/spanish/grammar-checker.png" width="782" height="460" alt="grammar-checker">
                                </picture>
                            </div>
                        </div>
                        <div id="proofread" class="tab-pane fade">
                            <p>您可以使用 Trinka 編輯您的 Word 文件，不論是英文還是西班牙文都可以！它會保留您原始的排版，還能獲得一份語言分數報告，並套用您偏好的寫作風格設定。最後您可以下載一份保留追蹤修訂的檔案。</p>
                            <div class="image" [ngClass]="{'hidden': showLanguages}">
                                <picture>
                                    <source srcset="/assets/images/homepage/proofread.webp" type="image/webp">
                                    <img src="/assets/images/homepage/proofread.png" width="762" height="460" alt="proofread file">
                                </picture>
                                <!-- <img src="/assets/images/homepage/proofread.svg" alt="proofread" /> -->
                                <div class="arrow-clip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="233" height="201" viewBox="0 0 233 201" fill="none">
                                        <path d="M34.7918 0.358398L71.9196 40.5096L45.7084 92.0693L100.977 82.1605L126.132 142.887L233 2.76102L34.7918 0.358398ZM27.9951 87.2802L38.2828 78.8388L25.0039 83.0393L23.6172 81.1043L29.1238 75.775L21.9402 78.6695C-5.52877 89.3362 -25.0078 115.918 -25.0078 147.08C-25.0177 157.036 -22.9884 166.889 -19.0448 176.031C-15.1012 185.173 -9.32697 193.411 -2.07803 200.236C-8.34641 189.246 -11.6343 176.808 -11.616 164.156C-11.616 133.382 7.8711 105.953 34.7837 95.1653L38.1942 86.9416L30.1317 90.4649L27.8661 87.4011L27.9951 87.2802ZM74.9027 66.1161L92.0839 35.8011L193.115 12.1619L74.9027 66.1161Z" fill="#763393"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="image" [ngClass]="{'hidden': !showLanguages}">
                                <picture>
                                    <source srcset="/assets/images/homepage/spanish/proofread.webp" type="image/webp">
                                    <img src="/assets/images/homepage/spanish/proofread.png" width="762" height="460" alt="proofread file">
                                </picture>
                                <!-- <img src="/assets/images/homepage/proofread.svg" alt="proofread" /> -->
                                <div class="arrow-clip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="233" height="201" viewBox="0 0 233 201" fill="none">
                                        <path d="M34.7918 0.358398L71.9196 40.5096L45.7084 92.0693L100.977 82.1605L126.132 142.887L233 2.76102L34.7918 0.358398ZM27.9951 87.2802L38.2828 78.8388L25.0039 83.0393L23.6172 81.1043L29.1238 75.775L21.9402 78.6695C-5.52877 89.3362 -25.0078 115.918 -25.0078 147.08C-25.0177 157.036 -22.9884 166.889 -19.0448 176.031C-15.1012 185.173 -9.32697 193.411 -2.07803 200.236C-8.34641 189.246 -11.6343 176.808 -11.616 164.156C-11.616 133.382 7.8711 105.953 34.7837 95.1653L38.1942 86.9416L30.1317 90.4649L27.8661 87.4011L27.9951 87.2802ZM74.9027 66.1161L92.0839 35.8011L193.115 12.1619L74.9027 66.1161Z" fill="#763393"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div id="latex" class="container tab-pane fade">
                            <p>想要在您的 LaTeX 文件中修正文法錯誤，同時又不影響現有的 TeX 程式碼嗎？透過這項功能，您可以立即獲得語言品質分數和即時修正，並且能夠追蹤所有的修改。</p>
                            <div class="image">
                                <picture>
                                    <source srcset="/assets/images/homepage/latex.webp" type="image/webp">
                                    <img src="/assets/images/homepage/latex.png" width="763" height="460" alt="latex grammar checker">
                                </picture>
                                <!-- <img src="/assets/images/homepage/latex.svg" alt="latex" /> -->
                            </div>
                        </div>
                        <div id="consistencyCheck" class="container tab-pane fade">
                            <p>Trinka 能找出您英文和西班牙文內容中的多種不一致問題，像是拼字、連字號與破折號、重音符號等等，讓您的寫作看起來更專業。</p>
                            <div class="image" [ngClass]="{'hidden': showLanguages}">
                                <picture>
                                    <source srcset="/assets/images/homepage/consistency-check.webp" type="image/webp">
                                    <img src="/assets/images/homepage/consistency-check.png" width="763" height="460" alt="consistency-checker">
                                </picture>
                                <!-- <img src="/assets/images/homepage/consistency-check.svg" class="img-fluid" alt="consistency checker" /> -->
                                <div class="arrow-clip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="269" height="254" viewBox="0 0 269 254" fill="none">
                                        <path d="M33.673 228.702L72.6369 215.684L79.655 219.102C95.8963 226.993 114.458 231.198 134.726 231.198C201.762 231.198 249.777 183.235 249.777 125.596C249.777 67.7446 202.107 19.9931 134.726 19.9931C67.3446 19.9931 19.6751 67.7446 19.6751 125.596C19.7885 147.734 27.0684 169.239 40.4226 186.883L46.9039 195.524L33.673 228.683V228.702ZM20.1162 253.471C18.381 254.053 16.5156 254.125 14.7404 253.68C12.9653 253.235 11.3544 252.29 10.0983 250.958C8.84207 249.625 7.993 247.96 7.65132 246.16C7.30965 244.36 7.48964 242.499 8.17006 240.798L25.1017 198.423C9.24733 177.452 0.614702 151.897 0.5 125.596C0.5 61.9653 51.9277 0.792603 134.726 0.792603C217.524 0.792603 268.952 61.9653 268.952 125.596C268.952 189.226 216.987 250.399 134.726 250.399C110.853 250.399 89.5302 245.253 71.2946 236.382L20.097 253.471H20.1162Z" fill="#763393" fill-opacity="0.2"/>
                                    </svg>
                                </div>
                                <div class="arrow-clip1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="242" height="309" viewBox="0 0 242 309" fill="none">
                                        <path d="M287.605 31.4762L240.12 47.3245L231.567 43.1637C211.773 33.5566 189.152 28.4375 164.451 28.4375C82.7537 28.4375 24.238 86.8283 24.238 157C24.238 227.429 82.3331 285.563 164.451 285.563C246.57 285.563 304.665 227.429 304.665 157C304.527 130.048 295.655 103.868 279.38 82.387L271.481 71.8682L287.605 31.4996L287.605 31.4762ZM304.127 1.32248C306.242 0.613771 308.515 0.52524 310.679 1.06735C312.842 1.60947 314.805 2.75958 316.336 4.38187C317.867 6.00412 318.902 8.03076 319.318 10.2224C319.735 12.414 319.515 14.679 318.686 16.75L298.051 68.3386C317.373 93.8688 327.894 124.98 328.034 157C328.034 234.465 265.358 308.938 164.451 308.938C63.5445 308.938 0.869073 234.465 0.869066 157C0.86906 79.5353 64.1988 5.06249 164.451 5.06248C193.546 5.06248 219.532 11.327 241.756 22.1262L304.151 1.32248L304.127 1.32248Z" fill="#763393" fill-opacity="0.2"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="image" [ngClass]="{'hidden': !showLanguages}">
                                <picture>
                                    <source srcset="/assets/images/homepage/spanish/consistency-check.webp" type="image/webp">
                                    <img src="/assets/images/homepage/spanish/consistency-check.png" width="763" height="460" alt="consistency-checker">
                                </picture>
                                <!-- <img src="/assets/images/homepage/consistency-check.svg" class="img-fluid" alt="consistency checker" /> -->
                                <div class="arrow-clip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="269" height="254" viewBox="0 0 269 254" fill="none">
                                        <path d="M33.673 228.702L72.6369 215.684L79.655 219.102C95.8963 226.993 114.458 231.198 134.726 231.198C201.762 231.198 249.777 183.235 249.777 125.596C249.777 67.7446 202.107 19.9931 134.726 19.9931C67.3446 19.9931 19.6751 67.7446 19.6751 125.596C19.7885 147.734 27.0684 169.239 40.4226 186.883L46.9039 195.524L33.673 228.683V228.702ZM20.1162 253.471C18.381 254.053 16.5156 254.125 14.7404 253.68C12.9653 253.235 11.3544 252.29 10.0983 250.958C8.84207 249.625 7.993 247.96 7.65132 246.16C7.30965 244.36 7.48964 242.499 8.17006 240.798L25.1017 198.423C9.24733 177.452 0.614702 151.897 0.5 125.596C0.5 61.9653 51.9277 0.792603 134.726 0.792603C217.524 0.792603 268.952 61.9653 268.952 125.596C268.952 189.226 216.987 250.399 134.726 250.399C110.853 250.399 89.5302 245.253 71.2946 236.382L20.097 253.471H20.1162Z" fill="#763393" fill-opacity="0.2"/>
                                    </svg>
                                </div>
                                <div class="arrow-clip1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="242" height="309" viewBox="0 0 242 309" fill="none">
                                        <path d="M287.605 31.4762L240.12 47.3245L231.567 43.1637C211.773 33.5566 189.152 28.4375 164.451 28.4375C82.7537 28.4375 24.238 86.8283 24.238 157C24.238 227.429 82.3331 285.563 164.451 285.563C246.57 285.563 304.665 227.429 304.665 157C304.527 130.048 295.655 103.868 279.38 82.387L271.481 71.8682L287.605 31.4996L287.605 31.4762ZM304.127 1.32248C306.242 0.613771 308.515 0.52524 310.679 1.06735C312.842 1.60947 314.805 2.75958 316.336 4.38187C317.867 6.00412 318.902 8.03076 319.318 10.2224C319.735 12.414 319.515 14.679 318.686 16.75L298.051 68.3386C317.373 93.8688 327.894 124.98 328.034 157C328.034 234.465 265.358 308.938 164.451 308.938C63.5445 308.938 0.869073 234.465 0.869066 157C0.86906 79.5353 64.1988 5.06249 164.451 5.06248C193.546 5.06248 219.532 11.327 241.756 22.1262L304.151 1.32248L304.127 1.32248Z" fill="#763393" fill-opacity="0.2"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd trinka-platform">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center ">
                    <h2>打造專屬你的寫作風格</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="platform-card">
                    <div class="card-top" id="paraphraser">
                        <span class="capella"><img src="/assets/images/homepage/capella-shape.svg" width="619" height="583" alt="capella" /></span>
                        <h3>
                            <img src="/assets/images/paraphraser-icon.svg" width="24" height="24"  alt="paraphraser-icon">
                            文章改寫
                        </h3>
                        <div class="list-wrapper-image">
                            <picture>
                                <source srcset="/assets/images/homepage/pharaphraser.webp" type="image/webp">
                                <img src="/assets/images/homepage/pharaphraser.png" width="322" height="263" alt="paraphraser">
                            </picture>
                        </div>
                    </div>
                    <div class="card-bottom">
                        <p>使用 Trinka 的文章改寫工具，讓你的寫作更清晰有條理，同時完美保留原意。現在支援英文和西班牙文，輕鬆提升表達力！</p>
                        <a [routerLink]="['/features/paraphraser']">了解更多 
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8.625 5.25L15.375 12L8.625 18.75" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="platform-card" id="plagiarism-check">
                    <div class="card-top">
                        <span class="capella"><img src="/assets/images/homepage/capella-shape1.svg" width="619" height="583" alt="capella" /></span>
                        <h3>
                            <img src="/assets/images/plag-check-icon.svg" width="24" height="24" alt="Plagiarism Checker">
                            抄襲檢測
                        </h3>
                        <div class="list-wrapper-image">
                            <picture>
                                <source srcset="/assets/images/homepage/plag-check.webp" type="image/webp">
                                <img src="/assets/images/homepage/plag-check.png" class="plag-check-img" width="332" height="275" alt="Plagiarism Checker">
                            </picture>
                            <!-- <img src="/assets/images/homepage/plag-check.svg" class="img-fluid" alt="Plagiarism Checker" style="transform: translate(30px, 0px);" /> -->
                        </div>
                    </div>
                    <div class="card-bottom">
                        <p>以超值價格，使用業界領先的抄襲檢測工具。掃描全球最大資料庫（包含所有頂尖出版商付費內容），幫你徹底把關文件原創性！</p>
                        <a [routerLink]="['/features/plagiarism-check']">了解更多 
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8.625 5.25L15.375 12L8.625 18.75" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>   
    </div>       
</section>

<section class="list-wrapper-style-2 section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center ">
                    <h2>寫作從未如此輕鬆</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="writing_tool_content">
            <div class="row no-margin align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>學術和技術寫作</h3>
                        <p>Trinka 能抓出其他文法檢查工具抓不到的學術寫作難題，從高級英文文法到學術寫作的語氣和風格，Trinka 通通幫你把關，讓你寫得更專業、更精準！</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-image bg-features">
                        <picture>
                            <source srcset="/assets/images/homepage/technical-writing.webp" type="image/webp">
                            <img src="/assets/images/homepage/technical-writing.png" width="436" height="359" alt="academic grammar checker">
                        </picture>
                        <!-- <img src="/assets/images/homepage/technical-writing.png" class="img-fluid" alt="technical" /> -->
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 34 34" fill="none">
                                <path d="M32.7327 16.5311C33.1681 16.6922 33.1681 17.3078 32.7327 17.4689L21.8072 21.5118C21.6703 21.5624 21.5624 21.6703 21.5118 21.8072L17.4689 32.7327C17.3078 33.1681 16.6922 33.1681 16.5311 32.7327L12.4882 21.8072C12.4376 21.6703 12.3297 21.5624 12.1928 21.5118L1.26725 17.4689C0.831943 17.3078 0.831943 16.6922 1.26725 16.5311L12.1928 12.4882C12.3297 12.4376 12.4376 12.3297 12.4882 12.1928L16.5311 1.26725C16.6922 0.831944 17.3078 0.831943 17.4689 1.26725L21.5118 12.1928C21.5624 12.3297 21.6703 12.4376 21.8072 12.4882L32.7327 16.5311Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="writing_tool_content mt-40">
            <div class="row no-margin flex-row-reverse align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>專業寫作好幫手</h3>
                        <p>Trinka 幫你找出文法錯誤、分析句子結構，推薦最佳用字，並兼顧美式與英式英語風格，幫你提升寫作品質。</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-image bg-features">
                        <picture>
                            <source srcset="/assets/images/homepage/general-writing.webp" type="image/webp">
                            <img src="/assets/images/homepage/general-writing.png" width="371" height="287" alt="grammar checker for general writing">
                        </picture>
                        <!-- <img src="/assets/images/homepage/general-writing.svg" class="img-fluid" alt="general-writing" /> -->
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 34 34" fill="none">
                                <path d="M32.7327 16.5311C33.1681 16.6922 33.1681 17.3078 32.7327 17.4689L21.8072 21.5118C21.6703 21.5624 21.5624 21.6703 21.5118 21.8072L17.4689 32.7327C17.3078 33.1681 16.6922 33.1681 16.5311 32.7327L12.4882 21.8072C12.4376 21.6703 12.3297 21.5624 12.1928 21.5118L1.26725 17.4689C0.831943 17.3078 0.831943 16.6922 1.26725 16.5311L12.1928 12.4882C12.3297 12.4376 12.4376 12.3297 12.4882 12.1928L16.5311 1.26725C16.6922 0.831944 17.3078 0.831943 17.4689 1.26725L21.5118 12.1928C21.5624 12.3297 21.6703 12.4376 21.8072 12.4882L32.7327 16.5311Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <app-key-features-of-trinka></app-key-features-of-trinka>
</section>

<section class="section-pd-sm trinka-banner gcList">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-white text-center ">
                    <h2 class="text-white">無論何時何地，皆能使用 </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-lg-10 col-md-12">
                <div class="icon-list">
                    <span *ngFor="let icon of iconsList; trackBy: trackByFn">
                        <img [src]="icon.src" [alt]="icon.alt" [width]="icon.width" [height]="icon.height" loading="lazy">
                    </span>
                </div>
                <p>還有更多功能等你發掘。</p>
            </div>
        </div>
    </div>
</section>

<app-safe-secure></app-safe-secure>

<section class="trinka-business section-pd-sm">
    <div class="shape">
        <svg xmlns="http://www.w3.org/2000/svg" width="745" height="472" viewBox="0 0 745 472" fill="none">
            <path d="M310.653 0H745V472H0L310.653 0Z" fill="#EEEBFF"/>
        </svg>
    </div>
    <div class="trinka_container container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="trinka-title mb-0">
                    <h2 class="text-white">Trinka 企業版</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p class="text-white">輕鬆將 Trinka 企業版整合進您的工作流程，並根據公司需求量身打造專屬方案，靈活配置功能與設定。多種合作模式與價格方案，滿足不同規模與預算需求。 </p>
                    <div class="btn-group mt-40">
                        <a [routerLink]="['/enterprise']" class="white-btn" aria-label="Explore More">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-md-12">
                <div class="card">
                    <div class="media">
                        <div class="media-left">
                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M35.2122 9.89046C35.2122 9.44863 34.8542 9.09106 34.4123 9.09106C33.9757 9.09106 33.4887 9.09106 33.311 9.09106C28.3942 9.09106 24.0752 7.27667 20.5845 3.96299C20.2584 3.65343 19.7426 3.65343 19.4165 3.963C15.9259 7.27656 11.6073 9.09106 6.69068 9.09106C6.51291 9.09106 6.02576 9.09106 5.58908 9.09106C5.14727 9.09106 4.78922 9.44861 4.7892 9.89042C4.78915 11.1266 4.78906 13.5248 4.78906 15.1113C4.78906 25.9371 11.2528 35.0337 20.0006 37.6128C28.7485 35.0337 35.2122 25.9371 35.2122 15.1113C35.2122 13.5248 35.2122 11.1266 35.2122 9.89046Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <g clip-path="url(#clip0_2647_2203)">
                                <path d="M14.6978 29.25H25.3039C25.7432 29.25 26.0993 28.8938 26.0993 28.4545V19.4394C26.0993 19.0001 25.7432 18.6439 25.3039 18.6439H24.5084V16.2576C24.5084 13.7721 22.4863 11.75 20.0008 11.75C17.5154 11.75 15.4933 13.7721 15.4933 16.2576V18.6439H14.6978C14.2585 18.6439 13.9023 19.0001 13.9023 19.4394V28.4545C13.9023 28.8938 14.2585 29.25 14.6978 29.25ZM20.7963 24.2114V25.2727C20.7963 25.712 20.4401 26.0682 20.0008 26.0682C19.5615 26.0682 19.2054 25.712 19.2054 25.2727V24.2114C18.8836 23.9693 18.6751 23.5843 18.6751 23.1515C18.6751 22.4205 19.2698 21.8258 20.0008 21.8258C20.7319 21.8258 21.3266 22.4205 21.3266 23.1515C21.3266 23.5843 21.1181 23.9693 20.7963 24.2114ZM17.0842 16.2576C17.0842 14.6493 18.3926 13.3409 20.0008 13.3409C21.6091 13.3409 22.9175 14.6493 22.9175 16.2576V18.6439H17.0842V16.2576Z" fill="#7A28A0"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_2647_2203">
                                <rect width="17.5" height="17.5" fill="white" transform="translate(11.25 11.75)"/>
                                </clipPath>
                                </defs>
                            </svg> 
                        </div>
                        <div class="media-body">
                            <h3>資料安全</h3>
                            <p>全面滿足您的合規需求與資料保護標準。</p>
                        </div>
                    </div>
                    <div class="media">
                        <div class="media-left">
                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2647_2208)">
                                <path d="M36.166 11.8334H26.166" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.50065 11.8334H2.83398" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.1673 18.4167C19.8032 18.4167 22.7507 15.4692 22.7507 11.8333C22.7507 8.19746 19.8032 5.25 16.1673 5.25C12.5314 5.25 9.58398 8.19746 9.58398 11.8333C9.58398 15.4692 12.5314 18.4167 16.1673 18.4167Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M36.1667 30.1666H29.5" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.834 30.1666H2.83398" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M22.8333 36.75C26.4692 36.75 29.4167 33.8026 29.4167 30.1667C29.4167 26.5308 26.4692 23.5834 22.8333 23.5834C19.1975 23.5834 16.25 26.5308 16.25 30.1667C16.25 33.8026 19.1975 36.75 22.8333 36.75Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_2647_2208">
                                <rect y="0.5" width="40" height="40" rx="19" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>  
                        </div>
                        <div class="media-body">
                            <h3>自訂風格指南</h3>
                            <p>根據貴機構的寫作規範，量身打造專屬風格指南，提升整體一致性與專業形象。</p>
                        </div>
                    </div>
                    <div class="media">
                        <div class="media-left">   
                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="7.75" y="8.25" width="24.5" height="24.5" rx="3.25" fill="white" stroke="#7A28A0" stroke-width="1.5"/>
                                <path d="M14.7531 22.0563H17.1109L17.6266 23.3969H18.9203L16.5578 17.5H15.2969L13 23.3969H14.2656L14.7531 22.0563ZM15.9156 18.8734L16.7266 21.0625H15.1187L15.9156 18.8734ZM20.7438 21.175H21.5219C22.0609 21.175 22.4734 21.1469 22.7594 21.0906C22.9703 21.0437 23.1766 20.95 23.3781 20.8094C23.5797 20.6687 23.7484 20.4766 23.8797 20.2281C24.0109 19.9797 24.0766 19.675 24.0766 19.3141C24.0766 18.8453 23.9641 18.4609 23.7344 18.1656C23.5047 17.8703 23.2234 17.6781 22.8859 17.5891C22.6656 17.5281 22.1922 17.5 21.4703 17.5H19.5531V23.3969H20.7438V21.175ZM20.7438 18.4984H21.3203C21.7516 18.4984 22.0328 18.5125 22.1781 18.5406C22.3703 18.5734 22.5297 18.6625 22.6562 18.8031C22.7828 18.9437 22.8438 19.1219 22.8438 19.3328C22.8438 19.5062 22.7969 19.6609 22.7078 19.7922C22.6187 19.9234 22.4922 20.0219 22.3375 20.0828C22.1781 20.1437 21.8641 20.1766 21.3953 20.1766H20.7438V18.4984ZM25.0141 17.5H26.2047V23.3969H25.0141V17.5Z" fill="#7A28A0"/>
                                <path d="M25.5109 29.5047H11.6453C11.2563 29.5047 10.9375 29.1859 10.9375 28.7969V14.9688C10.9375 14.7109 10.7266 14.5 10.4688 14.5C10.2109 14.5 10 14.7109 10 14.9688V28.7969C10 29.7063 10.7359 30.4422 11.6453 30.4422H25.5109C25.7688 30.4422 25.9797 30.2313 25.9797 29.9734C25.9797 29.7156 25.7734 29.5047 25.5109 29.5047Z" fill="#C084FC"/>
                                <path d="M15.5 7.5L15.5 3.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M18.5 7.5L18.5 3.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M21.5 7.5L21.5 3.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M24.5 7.5L24.5 3.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M33 15.5L37 15.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M33 18.5L37 18.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M33 21.5L37 21.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M33 24.5L37 24.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M3 15.5L7 15.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M3 18.5L7 18.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M3 21.5L7 21.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M3 24.5L7 24.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M15.5 37.5L15.5 33.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M18.5 37.5L18.5 33.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M21.5 37.5L21.5 33.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M24.5 37.5L24.5 33.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>   
                        </div>
                        <div class="media-body">
                            <h3>API 整合</h3>
                            <p>輕鬆將我們的企業級 API 整合至您的應用程式或工作流程中，強化系統效能與自動化能力。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="client_rating_logo section-pd">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center ">
                    <h2>深受全球廣大用戶好評</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-9">
                <div class="client_logo_right">
                    <div class="row">
                        <div class="col-md-3 col-6">
                            <div class="client-rating sourceforge">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/SourceForge_logo.png" loading="lazy" decoding="async" alt="source forge"  />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustpilot">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trustpilot-1.png" loading="lazy" decoding="async" alt="trustpilot" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star"></i></li>
                                </ul>
                                <p>4 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating product-hunt">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/product-hunt.png" loading="lazy" decoding="async" alt="product hunt" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating g2">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/G2_Crowd.png" loading="lazy" decoding="async" alt="g2" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating capterra">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/capterra-inc.png" loading="lazy" decoding="async" alt="capterra" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating chrome-tool">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/chrome.png" loading="lazy" decoding="async" alt="chrome" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>4.3 out of 5</p>
                            </div>
                        </div>
                        
                        
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustradius">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trust-radius.png" loading="lazy" decoding="async" alt="trust radius" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>8.4 out of 10</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating software-suggest">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/softwaresuggest-social.png" loading="lazy" decoding="async" alt="software suggest" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>

<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        為什麼文法這麼重要？
                                    </a>
                                </div>
    
                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>良好的文法能確保您的文字清晰、專業且精確。<br/>
                                        尤其在學術與技術領域，精準表達想法至關重要。<br/>
                                        透過文法檢查工具，您能有效識別並修正文稿錯誤，確保寫作品質達到高標準。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        如何在線檢查文法？
                                    </a>
                                </div>
    
                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>使用 Trinka AI 文法檢查工具，只需將文字貼入編輯器或上傳文件，Trinka 便會自動標示錯誤，並提供文法、標點與學術風格的修正建議，幫助您提升寫作品質。</p> 
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以將 Trinka 整合到 Microsoft Word 或瀏覽器中嗎？
                                    </a>
                                </div>
    
                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以！Trinka 提供 Microsoft Word 外掛和瀏覽器擴充功能，讓您在撰寫時隨時獲得即時寫作建議，跨平台輕鬆使用。</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以免費使用 Trinka 嗎？
                                    </a>
                                </div>
    
                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 提供免費方案，包含高級文法和語言檢查功能，讓你無負擔開始使用。若需要更多高級功能，例如高級文法檢查、抄襲檢測、敏感資料方案、Word 外掛等，也可以隨時升級。</p>
                                    </div>
                                </div>
                            </div>


                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Trinka 文法檢查工具的適用對象
                                    </a>
                                </div>
    
                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 是一款專為學生、研究人員、學者和專業人士打造的寫作助手，特別適合需要撰寫正式且專業的英文及西班牙文文件。</p>
                                        <p>不論您是正在撰寫研究論文、碩博士論文、報告，或是其他學術與技術性文件，Trinka 都能協助您確保每個句子都精確到位，讓您的內容清晰無誤。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Trinka 如何確保我的文件隱私？
                                    </a>
                                </div>
    
                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 採用企業級安全技術與加密機制，嚴格保護您的內容。
                                        </p>
                                        <p>
                                            您的文件在處理過程中始終保持高度安全與絕對保密。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>